export const FETCH_INTEGRATED_UNIT_REQUEST = 'FETCH_INTEGRATED_UNIT_REQUEST'
export const FETCH_INTEGRATED_UNIT_SUCCESS = 'FETCH_INTEGRATED_UNIT_SUCCESS'
export const FETCH_INTEGRATED_UNIT_FAILURE = 'FETCH_INTEGRATED_UNIT_FAILURE'

export const FETCH_INTEGRATED_UNITS_FILE_REQUEST = 'FETCH_INTEGRATED_UNITS_FILE_REQUEST'
export const FETCH_INTEGRATED_UNITS_FILE_SUCCESS = 'FETCH_INTEGRATED_UNITS_FILE_SUCCESS'
export const FETCH_INTEGRATED_UNITS_FILE_FAILURE = 'FETCH_INTEGRATED_UNITS_FILE_FAILURE'
